import { staleTimes, useQuery } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import { queryKeys, usePageContext } from '../usePageContext.ts';
import type { OrderDetail } from './orders.ts';

export type FollowPolicy = (detail: OrderDetail | undefined) => number | false;

const stayStill: FollowPolicy = () => false;

export const useOrderDetail = (
  api: TypedClient,
  orderId: string | null,
  follow: FollowPolicy = stayStill,
) => {
  const { tenantId } = usePageContext();
  const query = useQuery({
    queryKey: queryKeys.order(tenantId, orderId ?? ''),
    queryFn: () => api.get('/admin/orders/{id}', { path: { id: orderId ?? '' } }),
    enabled: orderId !== null,
    staleTime: staleTimes.orders,
    refetchInterval: (current) => follow(current.state.data),
  });
  const detail = query.data?.order.id === orderId ? query.data : undefined;
  return { query, detail };
};
